import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Search, SentimentDissatisfied } from "@mui/icons-material";
import { Avatar, Button, Stack,Grid,
  InputAdornment,
  TextField } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useHistory } from "react-router-dom";
import "./Header.css";

const Header = ({ children, hasHiddenAuthButtons, search }) => {
  // console.log(children)
  const history = useHistory();
  const logoutHandler =() =>{
    localStorage.removeItem("username")
    localStorage.removeItem("token")
    localStorage.removeItem("balance")
    window.location.reload()
  }
  const searchHandler = (e) =>{
    search(e,500)
  }
    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        {children !== undefined ? (<TextField
        className="search-desktop"
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        onChange = {searchHandler}
      />) : ("")}
        
        {hasHiddenAuthButtons ? ( children ? ( <Box className="leftContent">
          <Box><img src="avatar.png" alt={children} height="30px"></img></Box>
          <h5>{children}</h5>
        <Button variant="text" onClick={logoutHandler}>Logout</Button>
        </Box>) : ( <Box>
        <Button variant="text" onClick={() => history.push("/login")}>Login</Button>
       
        <Button variant="contained" className="button" onClick={() => history.push("/register")}>Register</Button>
        </Box>)
       ) : (<Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={() => history.push("/")}
        >
          Back to explore
        </Button>)}
        
      </Box>
    );
};

export default Header;
